<template>
	<div class="box">
		<div class="padding">
			<h5 class="_600">
				<span class="float-right text-muted">
					<a @click="loadData" class="no-select btn-subtle" v-tippy title="Refresh">
						<i class="fa fa-sync text-sm" :class="{ 'fa-spin': busy }"></i>
					</a>
				</span>
			</h5>
			<div class="py-3">
				<canvas id="projectdash-doughnut" v-chartjs="chartData" style="height: 223px"></canvas>
			</div>
		</div>
	</div>
</template>

<style scoped>
a {
	opacity: 0.35;
	transition: opacity 0.25s;
}
a:hover {
	opacity: 1;
}
table {
	width: 100%;
}
td {
	padding-bottom: 2rem;
}
</style>

<script>
import ReportingService from "@/services/ReportingService";
import fs from "@/services/FormatService";
import chartjs from "chart.js";
require("@/directives/chartjs");
import moment from "moment";

export default {
	name: "SchoolDashCompletion",

	props: ["districtID", "schoolID"],

	data() {
		return {
			fs: fs,
			busy: false,
			stats: {},
			chartData: {
				type: "doughnut",
				data: {
					labels: ["Loading"],
					datasets: [
						{
							data: [],
							borderWidth: 2,
							borderColor: ["#bd63bf", "#4968e7", "#49c3e7", "#22b66e"],
							backgroundColor: ["#bd63bfaa", "#4968e7aa", "#49c3e7aa", "#22b66eaa"],
							hoverBackgroundColor: ["#bd63bfdd", "#4968e7dd", "#49c3e7dd", "#22b66edd"],
							label: "Completion"
						}
					]
				},
				options: {
					tooltips: {
						mode: "point",
						titleFontSize: 14,
						bodyFontSize: 14,
						callbacks: {
							label: (item, data) => {
								let i = item.datasetIndex;
								let j = item.index;

								let val = data.datasets[i].data[j];
								let label = data.labels[j];
								return ` ${label}:`;
							},
							afterLabel: (item, data) => {
								let i = item.datasetIndex;
								let j = item.index;
								let val = data.datasets[i].data[j];
								return ` ${val} (${fs.calcPercent1d(val, this.stats.tot)})`;
							}
						}
					},
					maintainAspectRatio: false,
					legend: {
						position: "right",
						labels: {
							boxWidth: 12
						}
					},
					cutoutPercentage: 70
				}
			}
		};
	},
	created() {
		this.loadData();
	},
	watch: {
		schoolID() {
			this.loadData();
		}
	},
	methods: {
		loadData() {
			if (this.busy) {
				return;
			}

			this.busy = true;
			ReportingService.getSchoolCompletion(this.districtID, this.schoolID)
				.then(resp => {
					this.stats = resp.data;
					this.stats.pending = this.stats.total - (this.stats.complete + this.stats.withheld);
					this.loadChartData(this.stats);
				})
				.catch(err => {
					console.log(err);
				})
				.finally(() => {
					this.busy = false;
				});
		},

		loadChartData(stats) {
			this.chartData.data.datasets[0].data[0] = stats.uns;
			this.chartData.data.labels[0] = "Unscored";
			this.chartData.data.datasets[0].data[1] = stats.rel;
			this.chartData.data.labels[1] = "Scored Once";
			this.chartData.data.datasets[0].data[2] = stats.res;
			this.chartData.data.labels[2] = "Resolution";
			this.chartData.data.datasets[0].data[3] = stats.com;
			this.chartData.data.labels[3] = "Complete";
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/school_dashboard/SchoolDashCompletion.vue